<template>
    <div id="le-quartier">
        <HeaderGeneral banner="prochainement.jpg" />
        
        <div id="nav" class="li-lvl2">
            <Nav :links="links" :visible="visible" title="Le quartier en un coup d'oeil"/>
        </div>
        
    </div>
        
</template>

<script>
import HeaderGeneral from '@/components/Header.vue'
import Nav from '@/components/Nav.vue'
// @ is an alias to /src

export default {
    name: 'LeQuartier',
    components: {
        HeaderGeneral,
        Nav,
    },
    data: () => {
    
        return {
        
            links: [],
            visible: true
        
        };
    }


}
</script>